/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
import type { Application } from './Application'
import {
  ApplicationFromJSON,
  ApplicationFromJSONTyped,
  ApplicationToJSON,
} from './Application'

/**
 *
 * @export
 * @interface GetApplication200Response
 */
export interface GetApplication200Response {
  /**
   *
   * @type {boolean}
   * @memberof GetApplication200Response
   */
  status: boolean
  /**
   *
   * @type {Application}
   * @memberof GetApplication200Response
   */
  data: Application
}

/**
 * Check if a given object implements the GetApplication200Response interface.
 */
export function instanceOfGetApplication200Response(
  value: object
): value is GetApplication200Response {
  if (!('status' in value) || value['status'] === undefined) return false
  if (!('data' in value) || value['data'] === undefined) return false
  return true
}

export function GetApplication200ResponseFromJSON(
  json: any
): GetApplication200Response {
  return GetApplication200ResponseFromJSONTyped(json, false)
}

export function GetApplication200ResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): GetApplication200Response {
  if (json == null) {
    return json
  }
  return {
    status: json['status'],
    data: ApplicationFromJSON(json['data']),
  }
}

export function GetApplication200ResponseToJSON(
  value?: GetApplication200Response | null
): any {
  if (value == null) {
    return value
  }
  return {
    status: value['status'],
    data: ApplicationToJSON(value['data']),
  }
}
